@if ((userCredentials$ | async) === null || (userCredentials$ | async) === undefined || showEvenIfAlreadyLoggedIn) {
  <div [kgrLoading]="isLoading" [kgrLoadingBlocking]="true">
    @if (loginUserTokens.length < 1) {
      <form (submit)="onLogin()" [formGroup]="form" class="js-test-loginForm">
        @if (errorBadCredentials) {
          <div class="kgr-alert kgr-alert--error kgr-row">
            <div class="kgr-row" i18n>
              Der Benutzername oder das Passwort ist falsch. Bitte Angaben überprüfen oder Passwort zurück setzen.
            </div>
            <a [routerLink]="['/user/password/reset', { email: form.controls['username'].value }]" class="kgr-button" i18n
              >Passwort zurücksetzen</a
            >
          </div>
        }
        @if (errorOffline) {
          <kgr-errors errors="Es konnte keine Verbindung zum Server hergestellt werden."></kgr-errors>
        }
        @if (unexpectedError) {
          <kgr-errors errors="Es ist leider ein unerwarteter Fehler aufgetreten."></kgr-errors>
        }
        @if (unexpectedServerError) {
          <kgr-errors errors="Es ist leider ein unerwarteter Serverfehler aufgetreten."></kgr-errors>
        }
        @if (unexpectedError) {
          <div class="kgr-alert kgr-alert--error kgr-row" i18n>Es ist leider ein unerwarteter Fehler aufgetreten.</div>
        }
        <div class="kgr-grid kgr-grid--full kgr-grid--large-fit kgr-grid--gutters kgr-grid--bottom kgr-row">
          <div class="kgr-grid__cell">
            <kgr-form-field
              label="E-Mail"
              i18n-label
              [errors]="(validationErrors$ | async)?.username"
              [showErrorsIfPristine]="treatAllControlsAsDirty"
              [constrainedWidth]="false"
            >
              <input
                formControlName="username"
                type="email"
                class="kgr-input"
                autocomplete="email"
                (change)="form.controls['username'].setValue($event.target.value)"
              />
            </kgr-form-field>
          </div>
          <div class="kgr-grid__cell">
            <kgr-form-field
              label="Passwort"
              i18n-label
              [errors]="(validationErrors$ | async)?.password"
              [showErrorsIfPristine]="treatAllControlsAsDirty"
              [constrainedWidth]="false"
            >
              <kgr-password-input-control formControlName="password"></kgr-password-input-control>
            </kgr-form-field>
          </div>
          <div class="kgr-grid__cell kgr-grid__cell--bottom">
            <button [disabled]="isLoading" type="submit" class="kgr-button kgr-button--block kgr-button--accent" i18n>Anmelden</button>
          </div>
        </div>
        @if (form.get('tac')) {
          <kgr-form-field
            [errors]="(validationErrors$ | async)?.tac"
            [showErrorsIfPristine]="treatAllControlsAsDirty"
            [constrainedWidth]="false"
            class="kgr-row"
          >
            <kgr-checkbox-control
              formControlName="tac"
              i18n-label
              label="Hiermit stimme ich den <a href='{{
                termsAndConditionsUrl
              }}' target='_blank' rel='noreferrer' class='kgr-link'>App-Nutzungsbedingungen</a> zu."
            ></kgr-checkbox-control>
          </kgr-form-field>
        }
        <a [routerLink]="['/user/password/reset']" (click)="cancelLogin()" class="kgr-link kgr-clickable kgr-clickable--touchy" i18n>
          Passwort vergessen
        </a>
      </form>
    }

    @if (loginUserTokens.length > 0) {
      <div class="kgr-row">
        <h2 class="kgr-headline kgr-headline--h3 kgr-row kgr-row--extraSmallMargin" i18n>Wähle einen Account</h2>
        <p class="kgr-paragraph" i18n>
          Es existieren folgende Accounts für die E-Mail-Adresse {{ form.get('username').value }}. Bitte wählen:
        </p>

        <kgr-select-login-user (loginResult)="onMultiAccountLoginResult($event)"></kgr-select-login-user>
      </div>
    }
  </div>
}
